export default __webpack_public_path__ + "static/media/finished-payment.fb4bf909.svg";